import palette from '../palette';

export default {
  root: {
    '&.Mui-selected': {
      backgroundColor: palette.background.default
    },
    '&:hover': {
      backgroundColor: palette.background.default
    }
  }
};
